import * as React from 'react';

const RecaptchaContext = /*#__PURE__*/ React.createContext({});
const RecaptchaProvider = ({ children , settings  })=>{
    const context = {
        settings
    };
    return /*#__PURE__*/ React.createElement(RecaptchaContext.Provider, {
        value: context
    }, children);
};

export { RecaptchaContext, RecaptchaProvider };
//# sourceMappingURL=RecaptchaProvider.js.map
